/**
 * Analytics layer. Structure is ready for Google Analytics (gtag / dataLayer),
 * Meta Pixel (fbq) and TikTok Pixel (ttq). If a provider script is not present
 * on the page, the call is a no-op, so nothing breaks in preview.
 */

export const AFFILIATE_URL =
  'https://portal.elyonmarkets.com/client/register/69e28bf7dd1bb'

export type TrackingEvent =
  | 'page_view'
  | 'view_content'
  | 'cta_click'
  | 'register_click'

type Payload = Record<string, string | number | boolean>

interface TrackingWindow extends Window {
  dataLayer?: Payload[]
  gtag?: (...args: unknown[]) => void
  fbq?: (...args: unknown[]) => void
  ttq?: { track: (event: string, payload?: Payload) => void }
}

const META_EVENT_MAP: Record<TrackingEvent, string> = {
  page_view: 'PageView',
  view_content: 'ViewContent',
  cta_click: 'Lead',
  register_click: 'CompleteRegistration',
}

export function track(event: TrackingEvent, payload: Payload = {}): void {
  if (typeof window === 'undefined') return
  const w = window as TrackingWindow

  try {
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({ event, ...payload })
    w.gtag?.('event', event, payload)
    w.fbq?.('track', META_EVENT_MAP[event], payload)
    w.ttq?.track(META_EVENT_MAP[event], payload)
  } catch {
    /* analytics must never break the page */
  }
}

/** Fired by every button that sends the visitor to the affiliate link. */
export function trackRegisterClick(location: string, label: string): void {
  track('cta_click', { cta_location: location, cta_label: label })
  track('register_click', { cta_location: location, cta_label: label })
}
